/*
 * Copyright © 2021-present Protonbase Inc. All rights reserved.
 * The information contained in this software is confidential and proprietary to Protonbase Inc. and its subsidiaries. No part of this software may be used, copied, reproduced, modified, displayed, performed, executed, published, distributed, conveyed, stored, transmitted, or otherwise exploited in any form or by any means, including but not limited to electronic, mechanical, photocopying, recording, transcribing, without the prior written consent of Protonbase Inc.
 * Any violation of the above terms will constitute an infringement of copyright and will be subjected to legal action.
 */
import { Alert, Button, Form, InputNumber, Modal } from 'antd'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { requiredRule } from '@/formRules/baseRule'
import { useTranslateAmount } from '@/hooks/useTranslateAmount'

export function BalanceWarning() {
  const { t } = useTranslation()

  const { currency } = useTranslateAmount()
  const [open, setOpen] = useState(false)
  const [loading, setLoading] = useState(false)
  const [form] = Form.useForm()

  const onFinish = () => {
    setLoading(true)
    // accountClient.accountsSelfApi
    //   .setPassword(body)
    //   .then(() => {
    //     message.success(t('Set successfully'))
    //     setOpen(false)
    //   })
    //   .finally(() => setLoading(false))
  }

  return (
    <span>
      <Button onClick={() => setOpen(true)} type="link" size="small">
        {t('Available Balance Warning')}
      </Button>
      <span className="light-label">
        ({t('Threshold')}: 0.00 {currency})
      </span>
      <Modal title={t('Set Available Balance Warning')} open={open} onCancel={() => setOpen(false)} okButtonProps={{ loading }} destroyOnClose>
        <Alert
          className="margin-bottom-20"
          type="warning"
          message={
            <>
              <div>· {t('balance_warning_desc_1')}</div>
              <div>· {t('balance_warning_desc_2')}</div>
            </>
          }
        />
        <Form form={form} onFinish={onFinish}>
          <Form.Item name="confirm" label={`${t('Warning Threshold')}（${currency}）`} rules={[requiredRule()]}>
            <InputNumber min={0} style={{ width: 200 }} />
          </Form.Item>
        </Form>
      </Modal>
    </span>
  )
}
